import api from '../utils/request';
import { extractErrorMessage } from '../utils/apiErrorHandler';

class ResumeTemplatesAPI {
  async list(params = {}) {
    try {
      const response = await api.get('/resume-templates', { params });
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error) || '获取简历模板列表失败');
    }
  }

  async getDetail(id) {
    try {
      const response = await api.get(`/resume-templates/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error) || '获取简历模板详情失败');
    }
  }

  async getQuota() {
    try {
      const response = await api.get('/resume-templates/quota');
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        throw new Error('需要重新登录');
      }
      throw new Error(extractErrorMessage(error) || '获取下载配额失败');
    }
  }

  async downloadBlob(id) {
    try {
      // 先尝试作为JSON获取（OSS模式）
      const response = await api.post(`/resume-templates/${id}/download`, null);
      
      // 如果返回的是JSON（包含download_url），直接返回
      if (response.data?.data?.download_url) {
        return response.data;
      }
      
      // 如果响应是blob类型（本地文件模式），直接返回
      if (response.data instanceof Blob) {
        return response.data;
      }
      
      // 否则尝试作为blob重新请求（兼容旧版本）
      const blobResponse = await api.post(`/resume-templates/${id}/download`, null, {
        responseType: 'blob',
      });
      return blobResponse.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        const authError = new Error('需要重新登录');
        authError.status = 401;
        authError.response = error.response;
        throw authError;
      }
      const downloadError = new Error(extractErrorMessage(error) || '下载失败');
      downloadError.status = error?.response?.status;
      downloadError.response = error?.response;
      throw downloadError;
    }
  }

  async incrementView(id) {
    try {
      const response = await api.post(`/resume-templates/${id}/view`);
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error) || '浏览量更新失败');
    }
  }

  async toggleLike(id) {
    try {
      const response = await api.post(`/resume-templates/${id}/like`);
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        throw new Error('需要重新登录');
      }
      throw new Error(extractErrorMessage(error) || '点赞失败');
    }
  }

  async getFilters() {
    try {
      const response = await api.get('/resume-templates/filters');
      return response.data;
    } catch (error) {
      if (error?.response?.status === 401) {
        throw new Error('需要重新登录');
      }
      throw new Error(extractErrorMessage(error) || '获取筛选器选项失败');
    }
  }
}

const resumeTemplatesApi = new ResumeTemplatesAPI();
export default resumeTemplatesApi;

